import {
  GET_AWARDS_LIST_FAILURE,
  GET_AWARDS_LIST_REQUEST,
  GET_AWARDS_LIST_RESET,
  GET_AWARDS_LIST_SUCCESS,
} from "../../../../redux/types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const getAwardsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AWARDS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case GET_AWARDS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case GET_AWARDS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      }

    case GET_AWARDS_LIST_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default getAwardsListReducer
